/**
 * Infinite typewriter effect for header inline search placeholder.
 */
class HeaderSearchTypewriter {
  constructor(input) {
    this.input = input;
    this.text = (input.dataset.typewriterText || '').trim();
    this.charIndex = 0;
    this.isDeleting = false;
    this.typingDelay = 85;
    this.deletingDelay = 45;
    this.pauseAtEnd = 2200;
    this.pauseAtStart = 600;
    this.timerId = null;
    this.showCursor = true;
    this.cursorVisible = true;
    this.cursorIntervalId = null;

    if (!this.text.length) return;

    input.placeholder = '';
    input.setAttribute('aria-label', this.text);

    this.onFocus = this.handlePause.bind(this);
    this.onBlur = this.handleResume.bind(this);
    this.onInput = this.handlePause.bind(this);

    input.addEventListener('focus', this.onFocus);
    input.addEventListener('blur', this.onBlur);
    input.addEventListener('input', this.onInput);

    this.startCursorBlink();
    this.tick();
  }

  startCursorBlink() {
    this.cursorIntervalId = window.setInterval(() => {
      this.cursorVisible = !this.cursorVisible;
      if (!this.isPaused()) this.updatePlaceholder();
    }, 530);
  }

  isPaused() {
    return this.input.matches(':focus') || this.input.value.length > 0;
  }

  handlePause() {
    if (this.input.value.length > 0) {
      this.input.placeholder = '';
    }
  }

  handleResume() {
    if (!this.input.value.length) {
      this.charIndex = 0;
      this.isDeleting = false;
      this.tick();
    }
  }

  cursorChar() {
    if (!this.showCursor || !this.cursorVisible) return '';
    return '|';
  }

  updatePlaceholder() {
    const slice = this.text.substring(0, this.charIndex);
    this.input.placeholder = slice + this.cursorChar();
  }

  tick() {
    if (this.isPaused()) {
      this.schedule(400);
      return;
    }

    const { text } = this;

    if (!this.isDeleting) {
      if (this.charIndex < text.length) {
        this.charIndex += 1;
        this.updatePlaceholder();
        this.schedule(this.typingDelay);
        return;
      }

      this.isDeleting = true;
      this.schedule(this.pauseAtEnd);
      return;
    }

    if (this.charIndex > 0) {
      this.charIndex -= 1;
      this.updatePlaceholder();
      this.schedule(this.deletingDelay);
      return;
    }

    this.isDeleting = false;
    this.schedule(this.pauseAtStart);
  }

  schedule(delay) {
    window.clearTimeout(this.timerId);
    this.timerId = window.setTimeout(() => this.tick(), delay);
  }

  destroy() {
    window.clearTimeout(this.timerId);
    window.clearInterval(this.cursorIntervalId);
    this.input.removeEventListener('focus', this.onFocus);
    this.input.removeEventListener('blur', this.onBlur);
    this.input.removeEventListener('input', this.onInput);
  }
}

function initHeaderSearchTypewriter(root = document) {
  root.querySelectorAll('input[data-typewriter-text]').forEach((input) => {
    if (input._headerSearchTypewriter) {
      input._headerSearchTypewriter.destroy();
    }
    input._headerSearchTypewriter = new HeaderSearchTypewriter(input);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => initHeaderSearchTypewriter());
} else {
  initHeaderSearchTypewriter();
}

document.addEventListener('shopify:section:load', (event) => {
  initHeaderSearchTypewriter(event.target);
});
